import * as React from 'react';

import Relay16 from './Relay16';

export const relay16 = () => <Relay16 />;

export default {
    title: 'Icon|Line|Relay16',
    component: Relay16,
    parameters: {
        notes: "`import Relay16 from 'box-ui-elements/es/icon/line/Relay16';`",
    },
};
